import { CoordinatePoint } from 'types/point';
import { DEGREES_PER_RADIAN } from 'helpers/rotation';

export const rotateObjectRad = (diff: CoordinatePoint): number => Math.atan2(diff.y, diff.x);

export const rotateObjectDeg = (diff: CoordinatePoint): number => rotateObjectRad(diff) * DEGREES_PER_RADIAN;
